import RecursiveSelector from '@/components/RecursiveSelector';
import VuePhoneNumberInput from 'vue-phone-number-input';
import i18n from '../../locales';
import store from '../../store';
import LogService from '../../services/LogService';
import Container from 'typedi';
import Multiselect from 'vue-multiselect';
import showAlert from '@waypoint/vue-alert';
import axios from 'axios';
import userEscl from '../../locales/es-CL/user.json';
import userEsmx from '../../locales/es-MX/user.json';
import userEsco from '../../locales/es-CO/user.json';
import userEnus from '../../locales/en-US/user.json';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';
import showConfirmation from '../../confirmation/confirmationHandler';

export default {
  name: 'crud-user-modal',
  props: ['editMode', 'requireMassive', 'onlyDrivers', 'user', 'groups', 'callback'],
  components: {
    Multiselect,
    RecursiveSelector,
    VuePhoneNumberInput,
  },
  data() {
    return {
      logService: null,
      isCrudBusy: false,
      isMassiveActive: false,
      hoverInfoPass: false,
      loggedUserGroupName: '',
      selectedUser: {
        id: null,
        profile: null,
        firstName: null,
        lastName: null,
        username: null,
        phone: null,
        email: null,
        password: null,
        repeatPassword: null,
        showPassword: false,
        showPasswordRepeat: false,
        isOwner: false,
      },
      checkFields: {
        profile: true,
        firstName: true,
        lastName: true,
        username: true,
        limitCharacters: true,
        spaceInUsername: true,
        phone: true,
        email: true,
        invalidEmail: true,
        password: true,
        repeatPassword: true,
        notMatchRepeatPassword: true,
      },
      isUserCheck: true,
    };
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => {
      setTimeout(() => {
        this.$destroy(); // cleanup in component
        this.$el.remove();
      }, 300);
    });
    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      user: userEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      user: userEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      user: userEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      user: userEnus,
    });
  },
  created() {
    this.dataAccess = store.getters.dataAccess;
    this.logService = Container.get(LogService);
    this.prepareData();
  },
  methods: {
    prepareData() {
      if (this.editMode && this.user) {
        this.selectedUser.id = this.user.id;
        this.selectedUser.profile = this.user.group;
        this.selectedUser.firstName = this.user.firstName;
        this.selectedUser.lastName = this.user.lastName;
        this.selectedUser.fullName = this.user.firstName + ' ' + this.user.lastName;
        this.selectedUser.username = this.user.username;
        this.selectedUser.phone = this.user.phoneNumber;
        this.selectedUser.email = this.user.email;
        this.selectedUser.password = this.null;
        this.selectedUser.repeatPassword = this.null;
        this.selectedUser.showPassword = this.false;
        this.selectedUser.showPasswordRepeat = this.false;
        this.selectedUser.isOwner = this.user.groupName == 'Dueño de la cuenta' ? true : false;
      }
      if (this.onlyDrivers) {
        this.selectedUser.profile = this.user.profile;
      }
    },

    async processUser() {
      if (!this.isMassiveActive) {
        await this.createUser();
      } else {
        this.confirmUploadExcel();
      }
    },
    async createUser() {
      this.isCrudBusy = true;
      let profile = this.checkProfile();
      let firstName = this.checkFirstName();
      let lastName = this.checkLastName();
      let userName = this.checkUserName();
      let email = this.checkEmail();
      let phone = this.checkPhone();
      let password = this.checkPassword();
      let passwordEqual = this.checkPasswordEqual();
      let isValid = profile && firstName && lastName && userName && email && phone && password && passwordEqual;
      if (isValid) {
        let body = {
          enabled: true,
          firstName: this.selectedUser.firstName ? this.selectedUser.firstName : null,
          lastName: this.selectedUser.lastName ? this.selectedUser.lastName : null,
          email: this.selectedUser.email ? this.selectedUser.email : null,
          phoneNumber: this.selectedUser.phone ? this.selectedUser.phone.replace(/\s/g, '') : null,
          isDriver: this.selectedUser.profile && this.selectedUser.profile.name == 'Conductor' ? true : false,
          driver: {
            licenceNumber: null,
            licenceClass: null,
            licenceIssued: null,
            licenceExpires: null,
          },
          password: this.selectedUser.password,
          username: this.selectedUser.username,
          idGroup: this.selectedUser.profile.id,
        };
        await this.insertUser(body);
      }
      this.isCrudBusy = false;
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    async insertUser(body) {
      try {
        const response = await axios.post(`${store.getters.urlAPI}/api/user`, body, {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          showAlert(this.t('common.modals.exitoTitulo'), this.t('user.successful.insert'), 'success');
          this.callback(response.data.data);
          this.closeModal('crud-user-modal');
        }
      } catch (e) {
        this.isCrudBusy = false;
        console.log(e);
        this.logService.sendError({
          component: 'user',
          message: `insertUser fallo ${e.message}`,
          data: body,
        });
        if (e.response && e.response.data && e.response.data.username) {
          showAlert('Error', this.t('user.error.username'));
        } else if (e.response && e.response.data && e.response.data.email) {
          showAlert('Error', this.t('user.error.email'));
        } else {
          showAlert(this.t('common.modals.errorTitulo'), this.t('user.error.insert'), 'error');
        }
      }
    },
    async updateUser() {
      let profile = this.checkProfile();
      let firstName = this.checkFirstName();
      let lastName = this.checkLastName();
      let email = this.checkEmail();
      let phone = this.checkPhone();
      let password = this.passWordExist();
      let passwordEqual = this.passWordRepeatExist();
      let isValid = profile && firstName && lastName && email && phone && password && passwordEqual;
      if (isValid) {
        this.isMainPageBussy = true;
        let body = {
          enabled: true,
          firstName: this.selectedUser.firstName ? this.selectedUser.firstName : null,
          lastName: this.selectedUser.lastName ? this.selectedUser.lastName : null,
          email: this.selectedUser.email ? this.selectedUser.email : null,
          phoneNumber: this.selectedUser.phone ? this.selectedUser.phone : null,
          isDriver: this.selectedUser.profile && this.selectedUser.profile.name == 'Conductor' ? true : false,
          driver: {
            licenceNumber: null,
            licenceClass: null,
            licenceIssued: null,
            licenceExpires: null,
          },
          password: this.selectedUser.password,
          username: this.selectedUser.username,
          idGroup: this.selectedUser.profile.id,
        };
        await this.patchUser(body);
        this.isMainPageBussy = false;
      }
    },
    async patchUser(body) {
      try {
        const response = await axios.patch(`${store.getters.urlAPI}/api/user/${this.selectedUser.id}`, body, {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          showAlert(this.t('common.modals.exitoTitulo'), this.t('user.successful.update'), 'success');
          await this.callback();
          this.closeModal('crud-user-modal');
        }
      } catch (e) {
        this.logService.sendError({
          component: 'user',
          message: `patchUser fallo ${e.message}`,
          data: body,
        });
        this.isMainPageBussy = false;
        console.log(e);
        showAlert(this.t('common.modals.errorTitulo'), this.t('user.error.update'), 'error');
      }
    },
    checkProfile() {
      if (this.selectedUser.profile) {
        this.checkFields.profile = true;
        return true;
      }
      this.checkFields.profile = false;
      this.showPopover('fldprofile');
      return false;
    },
    checkFirstName() {
      if (this.selectedUser.firstName && this.selectedUser.firstName.length > 0) {
        this.checkFields.firstName = true;
        this.selectedUser.firstName = this.selectedUser.firstName.trim();
        return true;
      }
      this.checkFields.firstName = false;
      this.showPopover('fldFirstName');
      return false;
    },
    checkLastName() {
      if (this.selectedUser.lastName && this.selectedUser.lastName.length > 0) {
        this.checkFields.lastName = true;
        this.selectedUser.lastName = this.selectedUser.lastName.trim();
        return true;
      }
      this.checkFields.lastName = false;
      this.showPopover('fldLastName');
      return false;
    },
    checkUserName() {
      if (this.selectedUser.username && this.selectedUser.username.length > 0) {
        this.checkFields.username = true;
      } else {
        this.checkFields.username = false;
      }
      if (this.checkFields.username) {
        if (
          this.selectedUser.username &&
          this.selectedUser.username.length > 0 &&
          this.selectedUser.username.length <= 20
        ) {
          this.checkFields.limitCharacters = true;
        } else {
          this.checkFields.limitCharacters = false;
        }
        if (this.selectedUser.username && !/\s/g.test(this.selectedUser.username.trim())) {
          this.selectedUser.username = this.selectedUser.username.trim();
          this.checkFields.spaceInUsername = true;
        } else {
          this.checkFields.spaceInUsername = false;
        }
      }
      const isUserCheck =
        this.checkFields.spaceInUsername && this.checkFields.limitCharacters && this.checkFields.username;
      if (isUserCheck) {
        return true;
      } else {
        this.showPopover('fldUsername');
        return false;
      }
    },
    checkEmail() {
      if (this.selectedUser.email && this.selectedUser.email.length > 0) {
        this.checkFields.email = true;
      } else {
        this.checkFields.email = false;
      }
      if (this.checkFields.email) {
        if (this.selectedUser.email && this.isEmailValid()) {
          this.checkFields.invalidEmail = true;
        } else {
          this.checkFields.invalidEmail = false;
        }
      }
      let checkEmail = false;
      if (this.checkFields.email && this.checkFields.invalidEmail) {
        checkEmail = true;
        this.selectedUser.email = this.selectedUser.email.trim();
      }
      if (checkEmail) {
        return true;
      }
      this.showPopover('fldEmail');
      return false;
    },
    checkPhone() {
      if (this.selectedUser.phone && this.selectedUser.phone.length > 0) {
        const re = /^(?:(?:\+?\d{1,3})[-\s]?)?(?:\d{1,}[-\s]?)*\d{1,}$/;
        const isValidPhone = re.test(this.selectedUser.phone);
        if (isValidPhone) {
          this.selectedUser.phone = this.selectedUser.phone.trim();
          return true;
        }
        this.showPopover('fldphone');
        return false;
      }
      return true;
    },
    passWordExist() {
      if (this.selectedUser.password && this.selectedUser.password.length > 0) {
        return this.checkPassword();
      }
      return true;
    },
    passWordRepeatExist() {
      if (
        this.selectedUser.password &&
        this.selectedUser.password.length > 0 &&
        this.selectedUser.repeatPassword &&
        this.selectedUser.repeatPassword.length > 0
      ) {
        return this.checkPasswordEqual();
      }
      return true;
    },
    checkPassword() {
      if (this.selectedUser.password && this.selectedUser.password.length > 0) {
        this.checkFields.password = true;
      } else {
        this.checkFields.password = false;
      }
      if (
        this.checkFields.password &&
        this.isPwdLengthValid() &&
        this.isPwdUpperCaseValid() &&
        this.isPwdLowerCaseValid() &&
        this.isPwdNumberValid() &&
        this.isPwdSpecialCharacterValid()
      ) {
        this.selectedUser.password = this.selectedUser.password.trim();
        return true;
      }
      this.showPopover('fldPassword');
      return false;
    },
    isEmailValid() {
      const re = /^[a-zA-Z0-9.ñ_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(this.selectedUser.email.trim());
    },
    checkPasswordEqual() {
      if (this.selectedUser.password && this.selectedUser.password.length > 0) {
        this.checkFields.repeatPassword = true;
      } else {
        this.checkFields.repeatPassword = false;
      }
      if (this.checkFields.repeatPassword) {
        this.selectedUser.repeatPassword = this.selectedUser.repeatPassword.trim();
        if (this.selectedUser.password == this.selectedUser.repeatPassword) {
          this.checkFields.notMatchRepeatPassword = true;
        } else {
          this.checkFields.notMatchRepeatPassword = false;
        }
      }
      if (this.checkFields.repeatPassword && this.checkFields.notMatchRepeatPassword) {
        return true;
      }
      this.showPopover('fldRepeatPassword');
      return false;
    },
    isPwdLengthValid() {
      return this.selectedUser.password.trim().length >= 8;
    },
    isPwdUpperCaseValid() {
      const re = /[A-Z]+/;
      return re.test(this.selectedUser.password.trim());
    },
    isPwdLowerCaseValid() {
      const re = /[a-z]+/;
      return re.test(this.selectedUser.password.trim());
    },
    isPwdNumberValid() {
      const re = /[0-9]+/;
      return re.test(this.selectedUser.password.trim());
    },
    isPwdSpecialCharacterValid() {
      const re = /[^\w\s]+/;
      return re.test(this.selectedUser.password.trim());
    },
    switchVisibility(idPassword) {
      if (idPassword === 'password') {
        this.selectedUser.showPassword = this.selectedUser.showPassword === false ? true : false;
      }
      if (idPassword === 'repeatPassword') {
        this.selectedUser.showPasswordRepeat = this.selectedUser.showPasswordRepeat === false ? true : false;
      }
    },
    async confirmUploadExcel() {
      if (this.rowsExcelTranform.length < 1) {
        showAlert('Error', 'Debes seleccionar un archivo excel para cargar', 'error');
        return;
      }
      showConfirmation(
        this.t('user.crud.confirm'),
        this.t('user.crud.bodyConfirm'),
        async () => {
          await this.processExcel();
        },
        this.t('common.cruds.aceptar'),
        this.t('common.cruds.cerrar'),
      );
    },
    async processExcel() {
      this.isCrudBusy = true;

      let result;
      result = await this.saveMassUserRequest();

      if (result.status === 'DONE') {
        showAlert(this.t('common.modals.exitoTitulo'), this.t('user.crud.modalSuccessMassive'), 'success');
      } else {
        showAlert(this.t('user.crud.massive'), result.message, 'error');
      }
      this.isCrudBusy = false;
      this.closeExcel();
      if (result.status === 'DONE') {
        await this.callback();
      }
    },
    async saveMassUserRequest() {
      let response = null;
      let messageResponse = null;
      const usernameUsed = [];
      const emailUsed = [];
      let userProblem = null;
      this.rowsExcelTranform.forEach((element, index) => {
        let groupTemp = this.groups.find((x) => x.id === element.idGroup);
        if (element.username && usernameUsed.includes(element.username)) {
          userProblem = {
            status: 'FAIL',
            message: 'El nombre de usuario es unico por usuario, cambie el username de la fila ' + (index + 1),
          };
        }
        if (element.email && emailUsed.includes(element.email)) {
          userProblem = {
            status: 'FAIL',
            message: 'El email es unico por usuario, cambie el username de la fila ' + (index + 1),
          };
        }
        if (element.username) {
          usernameUsed.push(element.username);
        }
        if (element.email) {
          emailUsed.push(element.email);
        }
        if (element.firstName == null || element.firstName == undefined || element.firstName == '') {
          userProblem = {
            status: 'FAIL',
            message: 'Nombre en fila ' + (index + 1) + ' es obligatorio',
          };
        }
        if (groupTemp && groupTemp.name === 'Dueño de la cuenta') {
          userProblem = {
            status: 'FAIL',
            message: 'Perfil en fila ' + (index + 1) + ' no puede ser dueño de la cuenta',
          };
        }
        if (element.lastName == null || element.lastName == undefined || element.lastName == '') {
          userProblem = {
            status: 'FAIL',
            message: 'Apellido en fila ' + (index + 1) + ' es obligatorio',
          };
        }
        if (element.username == null || element.username == undefined || element.username == '') {
          userProblem = {
            status: 'FAIL',
            message: 'Nombre de usuario en fila ' + (index + 1) + ' es obligatorio',
          };
        }
        if (element.username && element.username.length > 20) {
          userProblem = {
            status: 'FAIL',
            message: 'Nombre de usuario excede los 20 caracteres en fila ' + (index + 1),
          };
        }
        if (element.idGroup == null || element.idGroup == undefined || element.idGroup == '') {
          userProblem = {
            status: 'FAIL',
            message: 'Perfil de usuario en fila ' + (index + 1) + ' no es valido',
          };
        }
        if (element.email == null || element.email == undefined || element.email == '') {
          userProblem = {
            status: 'FAIL',
            message: 'Email de usuario en fila ' + (index + 1) + ' es obligatorio',
          };
        }
        if (element.password == null || element.password == undefined || element.password == '') {
          userProblem = {
            status: 'FAIL',
            message: 'Contraseña de usuario en fila ' + (index + 1) + ' es obligatorio',
          };
        }
        if (
          userProblem == null &&
          !element.password &&
          element.password.trim().length < 8 &&
          /[A-Z]+/.test(element.password.trim()) &&
          /[a-z]+/.test(element.password.trim()) &&
          /[0-9]+/.test(element.password.trim()) &&
          /[^\w\s]+/.test(element.password.trim())
        ) {
          userProblem = {
            status: 'FAIL',
            message:
              'Usuario de fila: ' +
              (index + 1) +
              ' debe tener una ontraseña con al menos 8 caracteres, al menos un numero, un caracter especial y al menos una mayuscula',
          };
        }
      });
      if (userProblem != null) {
        return userProblem;
      }
      try {
        const body = this.rowsExcelTranform;
        const ret = await axios.post(`${store.getters.urlAPI}/api/user/request`, body, {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
            'x-api-key': store.getters.clientApiKey,
          },
        });
        response = ret.data;
        console.log('respuesta del servicio usuarios masivo', response);
      } catch (e) {
        console.log(e);
      }

      let result = {
        status: null,
        message: null,
      };

      if (response != null) {
        let statusResponse = await this.checkStatus(response.executionId);

        await new Promise((r) => setTimeout(r, 3000));
        let counter = 1;
        let failCounter = 0;
        while (statusResponse === 'notReady' && failCounter < 60) {
          statusResponse = await this.checkStatus(response.executionId);
          await new Promise((r) => setTimeout(r, 3000));
          failCounter++;
        }

        if (failCounter === 60) {
          throw new Error('Tiempo de espera excedido');
        }

        while (statusResponse.data.phase !== 'DONE' && statusResponse.data.phase !== 'FAIL' && counter < 60) {
          statusResponse = await this.checkStatus(response.executionId);
          counter++;
          await new Promise((r) => setTimeout(r, 3000));
        }

        if (counter >= 60) {
          result.status = 'FAIL';
          result.message = 'timeout';
          return result;
        }

        if (statusResponse.data.phase === 'DONE') {
          result.status = 'DONE';
          return result;
        } else {
          messageResponse = statusResponse;
          result.status = 'FAIL';
          result.message =
            messageResponse.data.message != 'Ha ocurrido un error: null'
              ? messageResponse.data.message
              : 'Ha ocurrido un error';
          return result;
        }
      } else {
        result.status = 'FAIL';
        result.message = 'noResponse';
        return result;
      }
    },
    async checkStatus(executionId) {
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        return await axios.get(`${store.getters.urlAPI}/api/user/checkStatus/${executionId}`, config);
      } catch (e) {
        this.logService.sendError({
          component: 'user',
          message: `checkStatus fallo ${executionId} ${e.message}`,
        });
        return 'notReady';
      }
    },
    closeExcel() {
      this.$bvModal.hide('crud-user-modal');
    },
    addfile(event) {
      this.file = event.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = () => {
        this.arrayBuffer = fileReader.result;
        let data = new Uint8Array(this.arrayBuffer);
        let arr = new Array();
        for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        let bstr = arr.join('');
        let workbook = XLSX.read(bstr, { type: 'binary', cellDates: true });
        let first_sheet_name = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[first_sheet_name];
        this.rowsExcel = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        this.readFileExcel();
      };
    },
    async readFileExcel() {
      this.rowsExcelTranform = [];
      this.prepareFileExcel();
      for (let row of this.rowsExcel) {
        let idGroupTemp = this.groups.find((x) => x.name === row.profile);
        let user = {
          enabled: true,
          firstName: row.firstName ? row.firstName.trim() : '',
          lastName: row.lastName ? row.lastName.trim() : '',
          email: row.email ? row.email.trim() : '',
          phoneNumber: row.phone != undefined ? String(row.phone).replace(/\s/g, '') : null,
          isDriver: row.profile && row.profile == 'Conductor' ? true : false,
          driver: {
            licenceNumber: null,
            licenceClass: null,
            licenceIssued: null,
            licenceExpires: null,
          },
          password: row.password ? row.password.trim() : null,
          username: row.username ? row.username.trim() : null,
          idGroup: idGroupTemp != undefined ? idGroupTemp.id : null,
        };
        this.rowsExcelTranform.push(user);
      }
    },
    async prepareFileExcel() {
      let firstName = 'Nombres (Obligatorio)';
      let lastName = 'Apellidos (Obligatorio)';
      let username = 'Nombre de usuario (Obligatorio)';
      let profile = 'Perfil (Obligatorio)';
      let phone = 'Telefono';
      let email = 'Correo electronico (Obligatorio)';
      let password = 'Contraseña (Obligatorio)';

      for (let row of this.rowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === firstName) {
            row.firstName = value;
          } else if (key.trim() === lastName) {
            row.lastName = value;
          } else if (key.trim() === username) {
            row.username = value;
          } else if (key.trim() === profile) {
            row.profile = value;
          } else if (key.trim() === phone) {
            row.phone = value;
          } else if (key.trim() === email) {
            row.email = value;
          } else if (key.trim() === password) {
            row.password = value;
          }
        });
      }
    },
    populateProfileExcel() {
      let profileExcel = '';
      let clonesGroups = [...this.groups];
      clonesGroups = clonesGroups.filter((group) => group.name !== 'Dueño de la cuenta');
      for (let i = 0; i < clonesGroups.length; i++) {
        if (i == clonesGroups.length - 1) {
          profileExcel += clonesGroups[i].name;
        } else {
          profileExcel += clonesGroups[i].name + ',';
        }
      }
      return profileExcel;
    },
    async buildExcel() {
      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet('Usuarios');

      const headers = [
        { header: 'Nombres (Obligatorio)', key: 'firstname', width: 20 },
        { header: 'Apellidos (Obligatorio)', key: 'lastname', width: 20 },
        { header: 'Nombre de usuario (Obligatorio)', key: 'username', width: 35 },
        { header: 'Perfil (Obligatorio)', key: 'profile', width: 20 },
        { header: 'Telefono', key: 'phone', width: 20 },
        { header: 'Correo electronico (Obligatorio)', key: 'email', width: 35 },
        { header: 'Contraseña (Obligatorio)', key: 'password', width: 25 },
      ];

      ws.columns = headers;

      ws.addRow({
        firstname: 'Antonio',
        lastname: 'Salazar',
        username: 'asalazar90',
        profile: 'Conductor',
        phone: '+ 569 11122233',
        email: 'usuario@ejemplo.cl',
        password: 'Contrasenia1.',
      });

      for (let i = 2; i < 200; i++) {
        ws.getCell(`D${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`"${await this.populateProfileExcel()}"`],
        };
      }

      const buffer = await wb.xlsx.writeBuffer();
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const fileExtension = '.xlsx';
      const blob = new Blob([buffer], { type: fileType });
      saveAs(blob, 'excel_usuarios_masivo_template' + fileExtension);
    },
    showPopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
    t(key, value) {
      return i18n.t(key, value);
    },
  },
  computed: {
    checkLenght() {
      if (this.selectedUser.password) {
        return this.isPwdLengthValid();
      } else {
        return false;
      }
    },
    checkUpperCase() {
      if (this.selectedUser.password) {
        return this.isPwdUpperCaseValid();
      } else {
        return false;
      }
    },
    checkLowerCase() {
      if (this.selectedUser.password) {
        return this.isPwdLowerCaseValid();
      } else {
        return false;
      }
    },
    checkNumber() {
      if (this.selectedUser.password) {
        return this.isPwdNumberValid();
      } else {
        return false;
      }
    },
    checkSpecialCharacter() {
      if (this.selectedUser.password) {
        return this.isPwdSpecialCharacterValid();
      } else {
        return false;
      }
    },
  },
};
